import { Expr } from './ast'
import { parse } from './grammar'

class Cell {
    id: string;
    formulaCache: string;
    code: Expr[];
    row: number;
    col: number;

    constructor(id: string, row: number, col: number) {
        this.id = id;
        this.row = row;
        this.col = col;
        this.formulaCache = "";
        this.code = [];
    }

    get formula(): string {
        return this.formulaCache;
    }

    set formula(src: string) {
        this.formulaCache = src;
        if (src.trim() == "")
            this.code = []
        else
            this.code = parseFormula(src)
    }
}

function parseFormula(src: string) {
    try {
        return parse(src)
    } catch (error) {
        return [{
            type: "error",
            message: error.message
        }]
    }
}

function colID(col: number): string {
    return String.fromCharCode("A".charCodeAt(0) + col);
}

function cellID(row: number, col: number): string {
    return colID(col) + (row + 1);
}

export { Cell, colID, cellID }